import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CheckIcon() {
    return (_jsxs("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "13", cy: "13", r: "12", stroke: "#587DEA", strokeWidth: '2' }), _jsx("path", { d: "M8 13L11 16L18 9", stroke: "#587DEA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}
